import type { ReactNode } from "react";
export const CARD =
  "rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark";
export function InfoRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex flex-col">
      <span className="text-[11px] text-body dark:text-bodydark">{label}</span>
      <span className="text-sm font-semibold text-black dark:text-white">
        {value ?? "—"}
      </span>
    </div>
  );
}
export function Spinner() {
  return (
    <svg
      aria-hidden="true"
      className="h-4 w-4 animate-spin"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      />
    </svg>
  );
}
